import React from "react";

import { LayoutAuth } from "@/shared/components/layout-auth/LayoutAuth";
import { LayoutUnauth } from "@/shared/components/layout-unauth/LayoutUnauth";
import { Provider as AnalyticsContextProvider } from "@/shared/contexts/analytics/Analytics";
import { Provider as AuthContextProvider } from "@/shared/contexts/auth/Auth";
import { Provider as ErrorContextProvider } from "@/shared/contexts/error/Error";
import { Provider as UserContextProvider } from "@/shared/contexts/user/User";
import { SentryRoutes } from "@/shared/services/sentry";
import { ModalProvider } from "react-modal-hook";
import { BrowserRouter, Route } from "react-router-dom";

import { routes as authRoutes } from "./auth/Auth";
import { routes as chatRoutes } from "./chat/Chat";
import { routes as consultationRoutes } from "./consultation/Consultation";
import { routes as playlistRoutes } from "./playlist/Playlist";
import { routes as postRoutes } from "./post/Post";
import { routes as profileRoutes } from "./profile/ProfileRoutes";
import { routes as pushRoutes } from "./push/Push";
import { routes as sharedRoutes } from "./shared-routes/Routes";
import { routes as studioRoutes } from "./studio/Studio";

const Oauth2Callback = React.lazy(
  () =>
    import(
      "@/features/authentication/presentation/pages/oauth2-callback/Oauth2Callback"
    )
);

const routes = [
  ...authRoutes,
  ...chatRoutes,
  ...consultationRoutes,
  ...profileRoutes,
  ...postRoutes,
  ...pushRoutes,
  ...playlistRoutes,
  ...studioRoutes,
  ...sharedRoutes
];

export interface RouteConfig {
  path: string;
  element: JSX.Element;
  isPrivate?: boolean;
  isPublic?: boolean;
}

export const Router = () => {
  return (
    <BrowserRouter basename="/app">
      <ErrorContextProvider>
        <AnalyticsContextProvider>
          <SentryRoutes>
            {routes.map((route, index) => (
              <Route
                element={
                  route.isPrivate ? (
                    <LayoutAuth>
                      <AuthContextProvider secure={true}>
                        <UserContextProvider>
                          <ModalProvider>{route.element}</ModalProvider>
                        </UserContextProvider>
                      </AuthContextProvider>
                    </LayoutAuth>
                  ) : (
                    <LayoutUnauth>
                      <AuthContextProvider secure={false}>
                        <UserContextProvider>
                          <ModalProvider>{route.element}</ModalProvider>
                        </UserContextProvider>
                      </AuthContextProvider>
                    </LayoutUnauth>
                  )
                }
                key={route.path}
                path={route.path}
              />
            ))}
            <Route element={<Oauth2Callback />} path="/oauth2/callback" />
          </SentryRoutes>
        </AnalyticsContextProvider>
      </ErrorContextProvider>
    </BrowserRouter>
  );
};
